export default {
  path: 'permissions',
  component: () => import(/* webpackChunkName: "permissions-list" */ '@/pages/permissions/PermissionsList'),
  meta: {title:'权限管理',cate:'所有系统管理'}
}